import { LOGIN_REQUEST, LOGIN_FAIL, LOGIN_SUCCESS, LOGOUT } from "../constants/authConstants";
import { loginUser } from "../services/authService";

export const login = (serviceNumber, password) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: LOGIN_REQUEST,
            });

            const data = await loginUser(serviceNumber);

            const user = data.resultSet?.[0];

            // if (!user) {
            //     throw new Error("User not found");
            // }

            // if (user.Password !== password) {
            //     throw new Error("Invalid password");
            // }

            if (!user || user.Password !== password) {
                throw new Error("Invalid username or password");
            }

            dispatch({
                type: LOGIN_SUCCESS,
                payload: user,
            });

            localStorage.setItem(
                "userInfo",
                JSON.stringify(user)
            );

            return user;
        } catch (error) {
            dispatch({
                type: LOGIN_FAIL,
                payload: error.message,
            })

            return null;
        }
    }
}

export const logout = () => (dispatch) => {
    localStorage.removeItem("userInfo");

    dispatch({
        type: LOGOUT
    });
};